import { useState, useEffect, useCallback } from 'react';

export function useMountTransition(open: boolean, duration = 200) {
  const [mounted, setMounted] = useState(open);
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    if (open) {
      setMounted(true);
    } else {
      setEntered(false);
      const t = setTimeout(() => setMounted(false), duration);
      return () => clearTimeout(t);
    }
  }, [open, duration]);

  // Callback ref on the animated node. Reading layout (offsetWidth) forces the
  // browser to commit the closed styles before we flip to entered, so the enter
  // transition always has a starting value and never snaps open.
  const ref = useCallback(
    (node: HTMLDivElement | null) => {
      if (node && open) {
        void node.offsetWidth; // force reflow
        setEntered(true);
      }
    },
    [open],
  );

  return { mounted, entered, ref };
}
